function adjustBadges() {
  const containers = document.querySelectorAll(".product-card");

  containers.forEach((container) => {
    let badges = container.querySelectorAll(".stoneBadge:not(.extra-badges)");
    let extraBadge = container.querySelector(".extra-badges");
    let containerWidth = container.clientWidth - 50;
    let totalWidth = 0;
    let visibleCount = 0;

    if (badges.length > 0 && extraBadge) {
      //if(badges.length > 0) {
      badges.forEach((badge) => {
        badge.style.display = "inline-block";
        totalWidth += badge.offsetWidth;
        if (totalWidth > containerWidth) {
          badge.style.display = "none";
        } else {
          visibleCount++;
        }
      });

      const hiddenCount = badges.length - visibleCount;
      if (hiddenCount > 0) {
        extraBadge.textContent = `+${hiddenCount}`;
        extraBadge.style.display = "inline-block";
      } else {
        extraBadge.style.display = "none";
      }
    }
  });
}

function onUrlChange(callback) {
  const pushState = history.pushState;
  history.pushState = function(...args) {
    pushState.apply(this, args);
    window.dispatchEvent(new Event("urlchange"));
  };
  
  const replaceState = history.replaceState;
  history.replaceState = function(...args) {
    replaceState.apply(this, args);
    window.dispatchEvent(new Event("urlchange"));
  };
  window.addEventListener("popstate", () => {
    window.dispatchEvent(new Event("urlchange"));
  });
  
  window.addEventListener("urlchange", callback);
}

document.addEventListener("DOMContentLoaded", () => {
  adjustBadges();
  window.addEventListener("resize", adjustBadges);
  onUrlChange(adjustBadges);
});

document.addEventListener("DOMContentLoaded", () => {
  function insertShippingSpan() {
    const upsellPrices = document.querySelectorAll(
      ".upsell-product-list-item:not(.purchased-product) .upsell-product-prices"
    );
    upsellPrices.forEach((priceElement) => {
      // Überprüfen, ob der span bereits vorhanden ist, um Duplikate zu vermeiden
      if (
        !priceElement.nextElementSibling ||
        !priceElement.nextElementSibling.classList.contains("upsell-shipping")
      ) {
        priceElement.insertAdjacentHTML(
          "afterend",
          '<div class=ed-delivery-wrapper><p class=text_container><span class="inventory inventory--high">Auf Lager </span>- <span class=colorfont-black>in 1-3 Werktage bei Dir</span></div>'
        );
        priceElement.insertAdjacentHTML(
          "afterend",
          '<div class="ruk_rating_snippet" rating-snippet-batch="4" data-retrieved="true" title="4.7 Stars " data-done="true" style="color: rgb(249, 188, 89);"><i aria-hidden="true" class="ruk-icon-percentage-star--100"></i><i aria-hidden="true" class="ruk-icon-percentage-star--100"></i><i aria-hidden="true" class="ruk-icon-percentage-star--100"></i><i aria-hidden="true" class="ruk-icon-percentage-star--100"></i><i aria-hidden="true" class="ruk-icon-percentage-star--75"></i></div>'
        );

        const shippingSpan = document.createElement("span");
        shippingSpan.classList.add("upsell-shipping");
        shippingSpan.textContent = "Kostenloser Hin & Rückversand ab 50€";
        priceElement.insertAdjacentElement("afterend", shippingSpan);
      }
    });
  }

  // MutationObserver Callback-Funktion
  const callback = function (mutationsList, observer) {
    for (let mutation of mutationsList) {
      if (mutation.type === "childList" || mutation.type === "subtree") {
        insertShippingSpan();
      }
    }
  };

  // Element überwachen
  const targetNode = document.querySelector("#un-modal-background-2");
  const config = { childList: true, subtree: true };

  const observer = new MutationObserver(callback);
  if (targetNode) {
    observer.observe(targetNode, config);
  }

  // Initiale Ausführung, falls schon Inhalte vorhanden sind
  insertShippingSpan();
});

// Überprüfen, ob das DOM vollständig geladen ist
document.addEventListener("DOMContentLoaded", function () {
  // Wähle alle Elemente mit der Klasse 'quickAdd_ab_btn' aus
  const elements = document.querySelectorAll(".quickAdd_ab_btn");

  // Füge jedem dieser Elemente einen Click-Event-Listener hinzu
  elements.forEach(function (element) {
    element.addEventListener("click", function () {
      // Code, der beim Klicken ausgeführt wird
      console.log(element.getAttribute("data-url"));
      addToCartExtras(element.getAttribute("data-url"));
      // Hier kannst du weitere Aktionen hinzufügen
    });
  });
});

async function addToCartExtras(url) {
  const product = await fetchProductJson(url);
  let variantId = false;
  let options1Picker = document.querySelectorAll(".variant-picker#option-1");
  let options2Picker = document.querySelectorAll(".variant-picker#option-2");

  if (options2Picker.length > 0) {
    product.product.variants.forEach(function (variante, index) {
      if (
        options1Picker[0].value == variante.option1 &&
        options2Picker[0].value == variante.option2
      ) {
        variantId = variante.id;
      }
    });
  } else {
    product.product.variants.forEach(function (variante, index) {
      if (options1Picker[0].value == variante.option1) {
        variantId = variante.id;
      }
    });
  }

  if (product && variantId) {
    // Sicherstellen, dass variantId definiert ist
    let formData = {
      items: [
        {
          id: variantId,
          quantity: 1,
        },
      ],
    };

    fetch(window.Shopify.routes.root + "cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    })
      .then((response) => {
        location.reload();
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  }
}

async function fetchProductJson(productHandle) {
  const url = `https://picmundoo.com/products/${productHandle}.json`;

  try {
    const response = await fetch(url);
    if (!response.ok) {
      throw new Error("Netzwerk-Antwort war nicht ok");
    }
    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Es gab ein Problem mit dem Fetch-Request:", error);
    return null;
  }
}

if (window.location.pathname.includes("pages/diamond-painting-anleitung")) {
  document.addEventListener("DOMContentLoaded", function () {
    document.querySelectorAll("button.button, a.button").forEach((button) => {
      if (button.textContent.trim() === "In den Warenkorb legen") {
        button.removeAttribute("href");
        button.onclick = async () => {
          try {
            await fetch("/cart/add.js", {
              method: "POST",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify({
                items: [{ id: 44448901366025, quantity: 1 }],
              }),
            });

            sessionStorage.setItem("openCartDrawer", "1");

            window.location.href =
              "/discount/HALLO?redirect=/collections/diamond-painting";
          } catch (e) {
            console.error("Cart-Error:", e);
          }
        };
      }
    });
  });
}

document.addEventListener('DOMContentLoaded', () => {
  if (sessionStorage.getItem('openCartDrawer') === '1') {
    sessionStorage.removeItem('openCartDrawer');
    document.dispatchEvent(new CustomEvent('variant:add', { detail: {} }));
  }
});


// -- START -- STARTER BOX LP
document.addEventListener('DOMContentLoaded', function () {
  const starterBoxLinks = document.querySelectorAll('a[href="#add-starter-box-to-cart"]');

  starterBoxLinks.forEach(link => {
    link.addEventListener('click', function (e) {
      e.preventDefault();
      lpCtaClick();
    });
  });

  const creatorBoxLinks = document.querySelectorAll('a[href="#add-creator-box-to-cart"]');

  creatorBoxLinks.forEach(link => {
    link.addEventListener('click', function (e) {
      e.preventDefault();
      lpCtaClick(56746703421705, 'INSIDER');
    });
  });
});

async function lpCtaClick(productId = 44448901366025, discountCode = 'HALLO') {
  try {
    await fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        items: [{ id: productId, quantity: 1 }],
      }),
    });

    sessionStorage.setItem("openCartDrawer", "1");

    window.location.href =
      `/discount/${discountCode}?redirect=/collections/diamond-painting`;
  } catch (e) {
    console.error("Cart-Error:", e);
  }
}
// -- END -- STARTER BOX LP



// -- START -- EG AUTO ADD TO CART
/*
(() => {
  const STORAGE_KEY = 'eg_initial_cart_check_v8';

  const OVERLAY_ID = 'eg-cart-check-overlay';
  const OVERLAY_STYLE_ID = 'eg-cart-check-overlay-styles';

  const MIN_CART_VALUE = 10000; // 100,00 € in Cent
  const EASYGIFT_TIMEOUT_MS = 10000;
  const EASYGIFT_POLL_INTERVAL_MS = 100;
  const EASYGIFT_REACTION_DELAY_MS = 500;

  const sleep = ms =>
    new Promise(resolve => setTimeout(resolve, ms));

  function waitForBody() {
    if (document.body) {
      return Promise.resolve();
    }

    return new Promise(resolve => {
      document.addEventListener(
        'DOMContentLoaded',
        resolve,
        { once: true }
      );
    });
  }

  function waitForPageLoad() {
    if (document.readyState === 'complete') {
      return Promise.resolve();
    }

    return new Promise(resolve => {
      window.addEventListener(
        'load',
        resolve,
        { once: true }
      );
    });
  }

  async function waitForEasyGift() {
    const startedAt = Date.now();

    while (Date.now() - startedAt < EASYGIFT_TIMEOUT_MS) {
      if (typeof window.EasyGift !== 'undefined') {
        return window.EasyGift;
      }

      await sleep(EASYGIFT_POLL_INTERVAL_MS);
    }

    throw new Error(
      `EasyGift wurde nach ${EASYGIFT_TIMEOUT_MS} ms nicht geladen`
    );
  }

  function showBlockingOverlay() {
    if (document.getElementById(OVERLAY_ID)) {
      return () => {};
    }

    if (!document.getElementById(OVERLAY_STYLE_ID)) {
      const style = document.createElement('style');

      style.id = OVERLAY_STYLE_ID;
      style.textContent = `
        #${OVERLAY_ID} {
          position: fixed;
          inset: 0;
          z-index: 2147483647;

          display: flex;
          align-items: center;
          justify-content: center;
          flex-direction: column;
          gap: 18px;

          width: 100%;
          height: 100%;

          background: rgba(255, 255, 255, 0.92);
          backdrop-filter: blur(3px);
          -webkit-backdrop-filter: blur(3px);

          cursor: wait;
          pointer-events: all;
        }

        #${OVERLAY_ID} .eg-cart-check-spinner {
          width: 48px;
          height: 48px;

          border: 5px solid rgba(0, 0, 0, 0.15);
          border-top-color: #111;

          border-radius: 50%;

          animation: eg-cart-check-spin 0.8s linear infinite;
        }

        #${OVERLAY_ID} .eg-cart-check-text {
          max-width: 320px;

          color: #111;
          font-family: inherit;
          font-size: 16px;
          font-weight: 600;
          line-height: 1.4;
          text-align: center;
        }

        @keyframes eg-cart-check-spin {
          to {
            transform: rotate(360deg);
          }
        }
      `;

      document.head.appendChild(style);
    }

    const overlay = document.createElement('div');

    overlay.id = OVERLAY_ID;
    overlay.setAttribute('role', 'status');
    overlay.setAttribute('aria-live', 'polite');
    overlay.setAttribute('aria-busy', 'true');
    overlay.tabIndex = -1;

    overlay.innerHTML = `
      <div
        class="eg-cart-check-spinner"
        aria-hidden="true"
      ></div>

      <div class="eg-cart-check-text">
        Dein Warenkorb wird aktualisiert …
      </div>
    `;

    const previousHtmlOverflow =
      document.documentElement.style.overflow;

    const previousBodyOverflow =
      document.body.style.overflow;

    const previousBodyAriaBusy =
      document.body.getAttribute('aria-busy');

    document.documentElement.style.overflow = 'hidden';
    document.body.style.overflow = 'hidden';
    document.body.setAttribute('aria-busy', 'true');

    document.body.appendChild(overlay);

    const inertStates = new Map();

    function disableElement(element) {
      if (
        !(element instanceof HTMLElement) ||
        element === overlay ||
        inertStates.has(element)
      ) {
        return;
      }

      inertStates.set(
        element,
        element.hasAttribute('inert')
      );

      element.setAttribute('inert', '');
    }

    Array.from(document.body.children).forEach(disableElement);


    const observer = new MutationObserver(mutations => {
      mutations.forEach(mutation => {
        mutation.addedNodes.forEach(node => {
          if (
            node instanceof HTMLElement &&
            node.parentElement === document.body
          ) {
            disableElement(node);
          }
        });
      });
    });

    observer.observe(document.body, {
      childList: true,
    });

    requestAnimationFrame(() => {
      overlay.focus({
        preventScroll: true,
      });
    });

    return function hideBlockingOverlay() {
      observer.disconnect();

      inertStates.forEach((wasAlreadyInert, element) => {
        if (!element.isConnected) {
          return;
        }

        if (!wasAlreadyInert) {
          element.removeAttribute('inert');
        }
      });

      overlay.remove();

      document.documentElement.style.overflow =
        previousHtmlOverflow;

      document.body.style.overflow =
        previousBodyOverflow;

      if (previousBodyAriaBusy === null) {
        document.body.removeAttribute('aria-busy');
      } else {
        document.body.setAttribute(
          'aria-busy',
          previousBodyAriaBusy
        );
      }
    };
  }

  async function fetchCart() {
    const response = await fetch('/cart.js', {
      credentials: 'same-origin',
      cache: 'no-store',
      headers: {
        Accept: 'application/json',
      },
    });

    if (!response.ok) {
      throw new Error(
        `Cart konnte nicht geladen werden: ${response.status}`
      );
    }

    return response.json();
  }

  async function changeQuantity(key, quantity) {
    const response = await fetch('/cart/change.js', {
      method: 'POST',
      credentials: 'same-origin',
      cache: 'no-store',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify({
        id: key,
        quantity,
      }),
    });

    if (!response.ok) {
      throw new Error(
        `Cart-Änderung fehlgeschlagen: ${response.status}`
      );
    }

    return response.json();
  }

  async function run() {
    if (sessionStorage.getItem(STORAGE_KEY)) {
      return;
    }

    await waitForBody();

    const hideBlockingOverlay =
      showBlockingOverlay();

    let keepOverlayUntilReload = false;

    let item = null;
    let originalQuantity = null;
    let quantityWasChanged = false;

    try {
      await waitForPageLoad();
      await waitForEasyGift();


      if (sessionStorage.getItem(STORAGE_KEY)) {
        return;
      }

      sessionStorage.setItem(
        STORAGE_KEY,
        'running'
      );

      const cart = await fetchCart();

      if (cart.total_price < MIN_CART_VALUE) {
        sessionStorage.setItem(
          STORAGE_KEY,
          'below_threshold'
        );

        return;
      }

      item = cart.items?.[0] ?? null;

      if (!item) {
        sessionStorage.setItem(
          STORAGE_KEY,
          'empty'
        );

        return;
      }

      originalQuantity = item.quantity;

      await changeQuantity(
        item.key,
        originalQuantity + 1
      );

      quantityWasChanged = true;

      await sleep(EASYGIFT_REACTION_DELAY_MS);

      await changeQuantity(
        item.key,
        originalQuantity
      );

      quantityWasChanged = false;

      sessionStorage.setItem(
        STORAGE_KEY,
        'done'
      );


      window.location.replace(
        window.location.href
      );

      keepOverlayUntilReload = true;
    } catch (error) {
      console.error(
        '[EasyGift initial check]',
        error
      );

      if (
        quantityWasChanged &&
        item &&
        originalQuantity !== null
      ) {
        try {
          await changeQuantity(
            item.key,
            originalQuantity
          );

          quantityWasChanged = false;
        } catch (restoreError) {
          console.error(
            '[EasyGift quantity restore]',
            restoreError
          );
        }
      }

      sessionStorage.setItem(
        STORAGE_KEY,
        'failed'
      );
    } finally {
      if (!keepOverlayUntilReload) {
        hideBlockingOverlay();
      }
    }
  }

  run().catch(error => {
    console.error(
      '[EasyGift bootstrap]',
      error
    );

    sessionStorage.setItem(
      STORAGE_KEY,
      'failed'
    );

    document
      .getElementById(OVERLAY_ID)
      ?.remove();

    document.documentElement.style.overflow = '';
    document.body.style.overflow = '';
  });
})();
*/
// -- END -- EG AUTO ADD TO CART